import React from 'react';

import { useAudioCaptionsContext } from '../../Audio/AudioCaptionsContextProvider';
import { useAreAudioCaptionsEnabled } from '../../Audio/editorHooks/captionPreferencesHooks';
import { useContentWrapperContext } from '../ContentWrapper';
import classNames from 'classnames';

import './caption.scss';

export const Caption: React.FC = () => {
  const areCaptionsEnabled = useAreAudioCaptionsEnabled();
  const { captions } = useAudioCaptionsContext();
  const { isControlVisible } = useContentWrapperContext();

  if (!captions || !areCaptionsEnabled) {
    return null;
  }

  return (
    <div className={classNames('caption__wrapper', { 'caption__wrapper--up': isControlVisible })}>
      <div className="caption">{captions}</div>
    </div>
  );
};
